import { z } from 'zod';
import { joinList, TAB_TYPES, TABS } from '../tabs.ts';
import { defineTool } from './types.ts';

export const openTabTool = defineTool({
  name: 'open_tab',
  // The types come from the catalogue, so a new tab type reaches the model without editing this text.
  description: `Add a tab to the user's app. Types: ${joinList(
    TAB_TYPES.map((t) => `${t} (${TABS[t].about}; needs ${TABS[t].needs})`),
    'and',
  )}. Then tell them in one short line what you added and why. If the result says it can't open yet, don't mention it.`,
  // No max on reason: openTab trims it; a long one shouldn't turn into a validation error for the model.
  params: z.object({ type: z.enum(TAB_TYPES), reason: z.string().min(3) }),
  execution: 'server',
  behavior: 'BLOCKING', // one memory write; the model mentions the tab right after
  fixtures: [{ name: 'progress', params: { type: 'progress', reason: 'So you can see your sounds improve.' } }],
});
